import tileNapoliAfragola01 from "assets/hard/AV-NAPOLI-FRAGOLA/01.jpg";
import tileNapoliAfragola02 from "assets/hard/AV-NAPOLI-FRAGOLA/02.jpg";
import tileNapoliAfragola03 from "assets/hard/AV-NAPOLI-FRAGOLA/03.jpg";
import tileNapoliAfragola04 from "assets/hard/AV-NAPOLI-FRAGOLA/04.jpg";
import tileNapoliAfragola05 from "assets/hard/AV-NAPOLI-FRAGOLA/05.jpg";
import tileNapoliAfragola06 from "assets/hard/AV-NAPOLI-FRAGOLA/06.jpg";
import tileNapoliAfragola07 from "assets/hard/AV-NAPOLI-FRAGOLA/07.jpg";
import tileNapoliAfragola08 from "assets/hard/AV-NAPOLI-FRAGOLA/08.jpg";
import tileNapoliAfragola09 from "assets/hard/AV-NAPOLI-FRAGOLA/09.jpg";
import tileNapoliAfragola10 from "assets/hard/AV-NAPOLI-FRAGOLA/10.jpg";
import tileNapoliAfragola11 from "assets/hard/AV-NAPOLI-FRAGOLA/11.jpg";
import tileNapoliAfragola12 from "assets/hard/AV-NAPOLI-FRAGOLA/12.jpg";
import tileNapoliAfragola13 from "assets/hard/AV-NAPOLI-FRAGOLA/13.jpg";
import tileNapoliAfragola14 from "assets/hard/AV-NAPOLI-FRAGOLA/14.jpg";
import tileNapoliAfragola15 from "assets/hard/AV-NAPOLI-FRAGOLA/15.jpg";
import tileNapoliAfragola16 from "assets/hard/AV-NAPOLI-FRAGOLA/16.jpg";
import tileNapoliAfragola17 from "assets/hard/AV-NAPOLI-FRAGOLA/17.jpg";
import tileNapoliAfragola18 from "assets/hard/AV-NAPOLI-FRAGOLA/18.jpg";
import tileNapoliAfragola19 from "assets/hard/AV-NAPOLI-FRAGOLA/19.jpg";
import tileNapoliAfragola20 from "assets/hard/AV-NAPOLI-FRAGOLA/20.jpg";
import tileNapoliAfragola21 from "assets/hard/AV-NAPOLI-FRAGOLA/21.jpg";
import tileNapoliAfragola22 from "assets/hard/AV-NAPOLI-FRAGOLA/22.jpg";
import tileNapoliAfragola23 from "assets/hard/AV-NAPOLI-FRAGOLA/23.jpg";
import tileNapoliAfragola24 from "assets/hard/AV-NAPOLI-FRAGOLA/24.jpg";
import tileNapoliAfragola25 from "assets/hard/AV-NAPOLI-FRAGOLA/25.jpg";
import tileNapoliAfragola26 from "assets/hard/AV-NAPOLI-FRAGOLA/26.jpg";
import tileNapoliAfragola27 from "assets/hard/AV-NAPOLI-FRAGOLA/27.jpg";
import tileNapoliAfragola28 from "assets/hard/AV-NAPOLI-FRAGOLA/28.jpg";
import tileNapoliAfragola29 from "assets/hard/AV-NAPOLI-FRAGOLA/29.jpg";
import tileNapoliAfragola30 from "assets/hard/AV-NAPOLI-FRAGOLA/30.jpg";
import tileNapoliAfragola31 from "assets/hard/AV-NAPOLI-FRAGOLA/31.jpg";
import tileNapoliAfragola32 from "assets/hard/AV-NAPOLI-FRAGOLA/32.jpg";
import tileNapoliAfragola33 from "assets/hard/AV-NAPOLI-FRAGOLA/33.jpg";
import tileNapoliAfragola34 from "assets/hard/AV-NAPOLI-FRAGOLA/34.jpg";
import tileNapoliAfragola35 from "assets/hard/AV-NAPOLI-FRAGOLA/35.jpg";
import tileNapoliAfragola36 from "assets/hard/AV-NAPOLI-FRAGOLA/36.jpg";
import fullImage from "assets/hard/AV-NAPOLI-FRAGOLA/complete.jpg";

import { ILevel, LevelDifficulties, LevelTypes } from "models";

export const napoliAfragola: ILevel = {
  difficulty: LevelDifficulties.hard,
  type: LevelTypes.station,
  name: "AV Napoli Afragola",
  fullImage,
  successDialogContent: {
    subtitle: "Hai (ri)costruito la stazione AV NAPOLI AFRAGOLA",
    link: `https://www.napolibari.it/content/fsinapolibari/it.html`,
    contents: [
      {
        text: "Crocevia futuristico dove si incontrano ",
        isBold: false,
      },
      {
        text: "bellezza, trasporti efficienti e sostenibilità ambientale",
        isBold: true,
      },
      {
        text:
          ": è qui che sorge la nuova stazione AV Napoli Afragola. Una vera e propria opera d’arte realizzata dall’architetto ",
        isBold: false,
      },
      {
        text: "Zaha Hadid",
        isBold: true,
      },
      {
        text:
          ". Ma non solo. Questa stazione guarda anche alle nuove prospettive dell’",
        isBold: false,
      },
      {
        text: "efficienza energetica",
        isBold: true,
      },
      {
        text: " grazie all’installazione di un ",
        isBold: false,
      },
      {
        text: "sistema solare termico",
        isBold: true,
      },
      {
        text: " dedicato alla produzione di acqua sanitaria e all’utilizzo di ",
        isBold: false,
      },
      {
        text: "caldaie a metano",
        isBold: true,
      },
      {
        text: " per il riscaldamento.",
        isBold: false,
      },
    ],
  },
  tiles: [
    tileNapoliAfragola01,
    tileNapoliAfragola02,
    tileNapoliAfragola03,
    tileNapoliAfragola04,
    tileNapoliAfragola05,
    tileNapoliAfragola06,
    tileNapoliAfragola07,
    tileNapoliAfragola08,
    tileNapoliAfragola09,
    tileNapoliAfragola10,
    tileNapoliAfragola11,
    tileNapoliAfragola12,
    tileNapoliAfragola13,
    tileNapoliAfragola14,
    tileNapoliAfragola15,
    tileNapoliAfragola16,
    tileNapoliAfragola17,
    tileNapoliAfragola18,
    tileNapoliAfragola19,
    tileNapoliAfragola20,
    tileNapoliAfragola21,
    tileNapoliAfragola22,
    tileNapoliAfragola23,
    tileNapoliAfragola24,
    tileNapoliAfragola25,
    tileNapoliAfragola26,
    tileNapoliAfragola27,
    tileNapoliAfragola28,
    tileNapoliAfragola29,
    tileNapoliAfragola30,
    tileNapoliAfragola31,
    tileNapoliAfragola32,
    tileNapoliAfragola33,
    tileNapoliAfragola34,
    tileNapoliAfragola35,
    tileNapoliAfragola36,
  ],
};
